module.exports = __webpack_public_path__ + "img/table-sm.1fd89b75.jpg";